import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOAN_APPLICATION_USER_GOBACK_START,
} from '../../actions/types'

import {
  loanApplicationUserGobackSuccess,
  loanApplicationUserGobackFailed,
} from '../../actions'

import { gobackLoanApplicationUser } from '../../requesters/loanApplicationUser'

function* loadApplicationUserGoback(action) {
  let { loanApplicationId } = action.payload

  const { response, error } = yield call(gobackLoanApplicationUser, loanApplicationId)

  if (response) {
    yield put(loanApplicationUserGobackSuccess(response))
  } else {
    yield put(loanApplicationUserGobackFailed(error.response.data.errors))
  }
}

export function* watchLoanApplicationUserGoback() {
  yield takeLatest(LOAN_APPLICATION_USER_GOBACK_START, loadApplicationUserGoback);
}
